module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_telegram.svg?f8ab31917554deb8bc606acc88ee2185";